export default __webpack_public_path__ + "static/media/emptyAlert.710753cc.svg";